<template>
    <v-snackbar v-model="snackbar.on"
        centered 
        multi-line
        :color="snackbar.color"
        :timeout="snackbar.timeout">
        <div class="text-center text-pre-wrap">
            {{ snackbar.text }}
        </div>
        <template v-slot:action="{ attrs }">
            <v-btn icon
                color="accent"
                v-bind="attrs" 
                @click="snackbar.on = false">
               <v-icon>mdi-close-circle</v-icon>
            </v-btn>
        </template>
    </v-snackbar>
</template>
<script>

export default {
    data() {
        return {}
    },
    computed: {
        snackbar() {
            return this.$store.getters.snackbar;
        }
    }
}
</script>